import { render } from "./ImageGallery.vue?vue&type=template&id=34baf59d&scoped=true&ts=true"
import script from "./ImageGallery.vue?vue&type=script&lang=ts"
export * from "./ImageGallery.vue?vue&type=script&lang=ts"

import "./ImageGallery.vue?vue&type=style&index=0&id=34baf59d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.40_webpack@5.109.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34baf59d"]])

export default __exports__